// -------------------------------------------------
// INITIAL STATE
// -------------------------------------------------
export const initialState = {
  data: {
    seoArea: [],
    seoMeta: {},
    seoRobotMeta: {
      maxFiltersPerFacet: '#',
      maxFilteredFacets: '#'
    }
  },
  error: null
}

// -------------------------------------------------
// HELPERS
// -------------------------------------------------
